import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import { serializedModelNameEquals } from './utils';

export function inferChatBedrockConverseManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    !serializedModelNameEquals(serializedModel, 'ChatBedrockConverse') ||
    params?.ls_provider !== 'amazon_bedrock' ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain_aws', 'chat_models', 'ChatBedrockConverse'],
    kwargs: {
      ...(params?.ls_model_name !== undefined && {
        model_id: params.ls_model_name,
      }),
      ...(params?.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params?.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      provider: undefined,
    },
  };
}
